
module fdm.pilotPerformance {

    export class PilotTopEventsPerAirportsController {

        readonly BarWidth: number = 18;
        readonly BarGap: number = 18;

        readonly barWithGapWidth = this.BarWidth + this.BarGap;
        readonly barWidthRatio = this.BarWidth / this.barWithGapWidth;
        readonly gapWidthRatio = this.BarGap / this.barWithGapWidth;

        public queryResult: any;
        public query: any;
        public data: any;
        public layout: any;
        public options: any;
        public events: any;
        public loading: any;
        // private xItems: Array<string> = [];
        // private xItemsPlaceholder: Array<string> = [];

        public constructor(
            private actionService: dg.actions.ActionService,
            private $scope: any,
            private navigationService: dg.navigation.NavigationService,
            private chartService: dg.lists.ChartService,
            private uiService: dgUtils.UiService,
            private severityLevelService: flightEvents.SeverityLevelService) {

        }

        $onChanges(changes) {
            if (changes.queryResult && changes.queryResult.currentValue) {
                // this.xItems = [];
                // this.xItemsPlaceholder = [];
                this.generateChart();
            }
        }

        public generateChart = () => {

            let minorTrace = {
                x: [],
                y: [],
                name: 'Minor',
                type: 'bar',
                marker: {
                    color: this.severityLevelService.getColor('Minor'),
                    opacity: 0.9,
                },
                width: this.barWidthRatio,
                text: [],
                id: [],
                textfont: {
                    size: 16,
                    color: '#fff'
                },
                hoverinfo: 'text',
                hoverlabel: {
                    bgcolor: '#535250',
                    font: { color: 'white' }
                }
                //textposition: 'auto'

            };
            let majorTrace = {
                x: [],
                y: [],
                name: 'Major',
                type: 'bar',
                marker: {
                    color: this.severityLevelService.getColor('Major'),
                    opacity: 0.9,
                },
                width: this.barWidthRatio,
                text: [],
                id: [],
                textfont: {
                    size: 16,
                    color: '#fff'
                },
                hoverinfo: 'text',
                hoverlabel: {
                    bgcolor: '#535250',
                    font: { color: 'white' }
                }
                //textposition: 'auto',
            };
            let criticalTrace = {
                x: [],
                y: [],
                name: 'Critical',
                type: 'bar',
                marker: {
                    color: this.severityLevelService.getColor('Critical'),
                    opacity: 0.9,
                },
                width: this.barWidthRatio,
                text: [],
                id: [],
                textfont: {
                    size: 16,
                    color: '#fff'
                },
                hoverinfo: 'text',
                hoverlabel: {
                    bgcolor: '#535250',
                    font: { color: 'white' }
                }
                //textposition: 'auto'
            };

            const airports = [];

            for (let i = 0; i < this.queryResult.items.length; i += 1) {
                let item = <iteraFDM.domain.pilotPerformance.PilotTopEventsByAirportInfo>this.queryResult.items[i];
                // this.xItems.push(item.airport.displayValue);
                // this.xItemsPlaceholder.push(item.airport.displayValue);

                minorTrace.x.unshift(item.airport.displayValue);
                majorTrace.x.unshift(item.airport.displayValue);
                criticalTrace.x.unshift(item.airport.displayValue);

                minorTrace.y.unshift(item.minorCount);
                majorTrace.y.unshift(item.majorCount);
                criticalTrace.y.unshift(item.criticalCount);


                minorTrace.text.unshift(`${item.airport.displayValue} (${item.minorCount})`);
                majorTrace.text.unshift(`${item.airport.displayValue} (${item.majorCount})`);
                criticalTrace.text.unshift(`${item.airport.displayValue} (${item.criticalCount})`);

                airports.push(item.airport);
            }

            // var minorLevelsBar = {
            //     x: this.xItems,
            //     y: minorLevels,
            //     marker: {
            //         color: this.severityLevelService.getColor("Minor")
            //     },
            //     type: 'bar',
            //     name: 'Minor'
            // }

            // var majorLevelsBar = {
            //     x: this.xItems,
            //     y: majorLevels,
            //     marker: {
            //         color: this.severityLevelService.getColor("Major")
            //     },
            //     type: 'bar',
            //     name: 'Major'
            // }

            // var criticalLevelsBar = {
            //     x: this.xItems,
            //     y: criticalLevels,
            //     marker: {
            //         color: this.severityLevelService.getColor("Critical")
            //     },
            //     type: 'bar',
            //     name: 'Critical'
            // }

            this.data = [minorTrace, majorTrace, criticalTrace];

            let width = this.queryResult.items.length * this.barWithGapWidth - this.BarGap + 39;

            if (this.queryResult.items.length == 0) {
                width = 50;   
            }

            this.layout = {
                hovermode: 'closest',
                barmode: 'stack',
                height: 150,
                bargap: 0.37,
                showlegend: false,
                //legend: {
                //    xanchor: "right",
                //    yanchor: "top",
                //    orientation: "h",
                //    y: 10,
                //    font: {
                //        //family: 'sans-serif',
                //        //size: 11,
                //        //color: '#686868'
                //    },
                //    x: 1
                //},
                margin: {
                    t: 10,
                    b: 20,
                    l: 45,
                    r: 30
                },
                xaxis: {
                    fixedrange: true,
                    tickfont: {
                        //family: "serif",
                        //size: 11,
                        //color: "#666666"
                    },
                },
                yaxis: {
                    autotick: true,
                    fixedrange: true,
                    rangemode: 'nonnegative'
                }
            };

            this.options = {
                showLink: false,
                displayLogo: false,
                displayModeBar: false,
                //staticPlot: true
            };

            this.events = (graph) => {

                graph.on('plotly_click', (data) => {

                    if (data.points && data.points[0] && data.points[0].data) {
                        let airportName = data.points[0].x;
                        let airport = airports.find(a => a.displayValue === airportName);
                        let level = data.points[0].data.name;

                        // let link = this.uiService.getLinkByPropertyAndLevel('airport', airport.id, level, this.queryResult);
                        let link = this.uiService.getLinkByProperty('airport', airport.id, this.queryResult);
                        this.navigationService.navigate(link, this.query);
                    }
                });

                //graph.on('plotly_click', (data) => {
                //    if (data.points) {
                //        let name = data.points[0].x;
                //        let link = this.uiService.getLinkByProperty('phase', name, this.queryResult);
                //        this.navigationService.navigate(link, this.query);
                //    }
                //});

                //graph.on('plotly_hover', (eventData) => {
                //    let infoText = this.chartService.getItemByIndex(eventData, this.xItems, this.xItemsPlaceholder);

                //    this.chartService.setPlaceholderText(infoText, eventData.points[0].x);
                //});
            };
        }

        //public getLinkByProperty(property: string, phaseName: string, queryResult: any) {
        //     for (let i = 0; i < queryResult.items.length; i += 1) {
        //         if (queryResult.items[i][property].displayValue == phaseName) {
        //             return queryResult.items[i].dgMeta.links.viewEvents;
        //         }
        //     }
        // }
    }


    angular.module('fdm.pilotPerformance').component('pilotTopEventsPerAirports', {
        bindings: {
            queryResult: '<',
            loading: '<',
            query: '<'
        },
        controller: PilotTopEventsPerAirportsController,
        templateUrl: '/digmo/src/lists/chart/plotly-chart-instance.html'
    });
}